import * as React from 'react'

import { Grid } from '@material-ui/core'

import { RouteComponentProps, withRouter } from 'react-router-dom'

interface INativeProps {
  termsOfUse: string
}
export interface IProps extends INativeProps, RouteComponentProps {}

class Content extends React.Component<IProps> {
  render() {
    const { termsOfUse } = this.props
    return (
      <Grid
        container={true}
        direction="column"
        justify="flex-start"
        alignItems="center"
        className="confirmation-wrapper page-min-content"
      >
        {termsOfUse ? <TermsConfirmation /> : null}
      </Grid>
    )
  }
}

const TermsConfirmation = () => {
  return null
}

const WithRouter = withRouter(Content)

export default (props: INativeProps) => <WithRouter {...props} />



// WEBPACK FOOTER //
// ./src/pages/Confirmation/content.tsx